import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ClientesSidebar from './sidebar';
import CriarCliente from './criarcliente';
import ConsultarClientes from './consultarclientes';


const ClientesLayout = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };

    const renderContent = () => {
        switch (selectedOption) {
            case 'criar':
                return <CriarCliente />;
            case 'consultarClientes':
                return <ConsultarClientes />
            case 'consultarEncomendas':
                return (
                    <Typography variant="h6">
                        Formulário para Encomendas por Cliente
                    </Typography>
                );
            default:
                return (
                    <Typography variant="body1" align="center">
                        Selecione uma opção do menu para exibir o formulário correspondente.
                    </Typography>
                );
        }
    };

    return (
        <Box sx={{ display: 'flex', height: '100vh' }}>
            {sidebarVisible && (
                <Box
                    sx={{
                        width: '300px',
                        borderRight: '1px solid #ccc',
                        position: 'relative'
                    }}
                >
                    <ClientesSidebar onOptionChange={handleOptionChange} />
                    {/* Botão para esconder o sidebar */}
                    <IconButton
                        onClick={() => setSidebarVisible(false)}
                        sx={{
                            position: 'absolute',
                            top: '10px',
                            right: '-20px',
                            backgroundColor: 'white',
                            boxShadow: 1
                        }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                </Box>
            )}
            {/* Quando o sidebar estiver oculto, exibe um botão para mostrá-lo */}
            {!sidebarVisible && (
                <IconButton
                    onClick={() => setSidebarVisible(true)}
                    sx={{
                        position: 'absolute',
                        left: '0px',
                        top: '50%',
                        backgroundColor: 'white',
                        boxShadow: 1,
                        zIndex: 1
                    }}
                >
                    <ChevronRightIcon />
                </IconButton>
            )}
            <Box sx={{ flexGrow: 1, p: 2, overflowY: 'auto', maxHeight: '100vh' }}>
            {renderContent()}
            </Box>
        </Box>
    );
};

export default ClientesLayout;
